var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"el-button",class:[
    _vm.type?'el-button--'+_vm.type:'',
    _vm.buttonSize?'el-button--'+_vm.buttonSize:'',
    {
        'is-disabled':_vm.disabled,
        'is-plain':_vm.plain
    }],attrs:{"type":"button"},on:{"click":_vm.handleClick}},[(_vm.$slots.icon)?[_vm._t("icon")]:(_vm.icon)?[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})]:_vm._e(),(_vm.$slots.default)?_c('span',{staticStyle:{"margin-left":"6px"}},[_vm._t("default")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }